export const initialBankAccountFilters = {
  fromDate: '',
  toDate: '',
  selectedFormat: {},
  submit: false,
  months: 1,
  isScheduled: false,
  id:''
};

export const initialManuallyEnteredValues = {
  fromDate: '',
  toDate: ''
};
